import { Action } from 'redux';

import ActionPayloadString from '../interfaces/actions/ActionPayloadString';

import * as Const from '../constants';

export const fetchLoginSuccess = (text: string): ActionPayloadString => {
  return {
    type: Const.LOGIN_RECEIVE_SUCCESS,
    payload: text,
  };
};

export const fetchLoginError = (): Action => {
  return {
    type: Const.LOGIN_RECEIVE_FAIL,
  };
};

export const fetchLoginInit = (): Action => {
  return {
    type: Const.LOGIN_RECEIVE_INIT,
  };
};
